import { RouteObject } from 'react-router';

const ticketAnsichtRoutes: RouteObject[] = [
  {
    path: 'lizenzhinweise',
    lazy: () => import('./page/lizenzhinweise-page.tsx'),
  },
];

export default ticketAnsichtRoutes;
